
import { useState, useEffect } from "react";

interface LessonType {
  id: string;
  title: string;
  duration: string;
  video_id: string;
  isCompleted: boolean;
}

interface ModuleType {
  id: string;
  title: string;
  lessons: LessonType[];
}

export function useNextLesson(
  activeLesson: LessonType | null,
  modulesList: ModuleType[]
) {
  const [nextLesson, setNextLesson] = useState<LessonType | null>(null);

  useEffect(() => {
    if (!activeLesson || !modulesList || modulesList.length === 0) {
      setNextLesson(null);
      return;
    }

    // Flatten all lessons from all modules
    const allLessons = modulesList.flatMap(module => module.lessons);
    
    // Find the index of the current lesson
    const currentIndex = allLessons.findIndex(lesson => lesson.id === activeLesson.id);
    
    // Set the next lesson if it exists
    if (currentIndex >= 0 && currentIndex < allLessons.length - 1) {
      setNextLesson(allLessons[currentIndex + 1]);
    } else {
      setNextLesson(null);
    }
  }, [activeLesson, modulesList]);

  return nextLesson;
}
